window.addEventListener('load', function(){

    //카드 헤더 추가
    const productColumns = document.querySelectorAll(".main-sec02 .m-mixed-layout__inner .m\\:column");
    productColumns.forEach(column => {
      const nameElement = column.querySelector(".m-product-card__name");
      if (!nameElement) return;
  
      const text = nameElement.textContent;
      const match = text.match(/\[([^\]]+)\]/); // [내용] 추출
  
      if (match) {
        const topTitle = document.createElement("div");
        topTitle.className = "top_title";
        topTitle.textContent = `[${match[1]}]`;
  
        column.insertBefore(topTitle, column.firstChild); // 가장 첫 자식으로 삽입
      }
    });

  
    // 메이크업 룩북
    const pcLook = document.querySelector('.m_05 .look.RW');
    const moLook = document.querySelector('.m_05 .look.RTMB');

    function handleResize() {
        if (window.innerWidth <= 1024) {
            if (pcLook) pcLook.remove();
        } else if (window.innerWidth >= 1025) {
            if (moLook) moLook.remove();
        }
    }

    // 초기 실행
    handleResize();

    // 창 크기 변경 감지
    window.addEventListener('resize', handleResize);

    const target_w = document.querySelectorAll('svg g.w');
    const target_g = document.querySelectorAll('svg g.g');
    const lookContainer = document.querySelector('.m_05 .look'); // 스크롤 컨테이너
    const lookItems = document.querySelectorAll('.look_item_wrap'); // .look_item_wrap 요소들

    target_w.forEach((element, index) => {
        element.addEventListener('click', (event) => {
            // 기존 .item_box 제거
            document.querySelectorAll('.item_box').forEach(el => el.remove());

            // 모든 요소에서 'on' 클래스 제거
            target_w.forEach(el => el.classList.remove('on'));
            target_g.forEach(el => el.classList.remove('on'));

            // 클릭한 요소만 'on' 클래스 추가
            target_w[index].classList.add('on');
            if (target_g[index]) {
                target_g[index].classList.add('on');
            }

            // 클릭한 위치에 .item_box 생성
            const itemBox = document.createElement('div');
            itemBox.classList.add('item_box');
            document.body.appendChild(itemBox);

            // `.look_item_wrap`의 내용을 itemBox에 추가
            if (lookItems[index]) {
                itemBox.innerHTML = lookItems[index].innerHTML;
            }

            
            
            // 위치 업데이트 함수
            const updatePosition = () => {
                const rect = element.getBoundingClientRect();
                const lookRect = lookContainer.getBoundingClientRect();
                
                // 첫 번째 target_w 요소의 rect.top 및 rect.right 값을 매번 업데이트
                const firstRect = target_w.length > 0 ? target_w[0].getBoundingClientRect() : null;
                const firstRectTop = firstRect ? firstRect.top + window.scrollY : 0;
                const firstRectBottom = firstRect ? firstRect.bottom + window.scrollY : 0;
                const firstRectRight = firstRect ? firstRect.right + window.scrollX : 0;

                if (window.innerWidth <= 1024) {
                    // 1024px 이하일 때 하단 고정
                    const lbWrap = document.querySelector('.lb_wrap');
                    const lbRect = lbWrap.getBoundingClientRect();
                    const lbBottom = lbRect.bottom + window.scrollY;
                    const lbRight = lbRect.left + window.scrollX;
                  
                    itemBox.style.left = `${lbRight + 10}px`;
                    itemBox.style.top = `${firstRectTop}px`; // 클릭한 위치에 고정
                } else{
                    // 1025px 이상일 때 .lb_wrap 요소의 우측 상단에 고정
                    const lbWrap = document.querySelector('.lb_wrap');
                    if (lbWrap) {
                        const lbRect = lbWrap.getBoundingClientRect();
                        const lbTop = lbRect.top + window.scrollY;
                        const lbRight = lbRect.right + window.scrollX;
            
                        itemBox.style.left = `${lbRight - itemBox.offsetWidth}px`;
                        itemBox.style.top = `${lbTop}px`;
                    }
                }
            };
            

            // 초기 위치 설정
            updatePosition();

            // **스크롤, 리사이즈, .look 스크롤 시 위치 업데이트**
            window.addEventListener('scroll', updatePosition);
            window.addEventListener('resize', updatePosition);
            lookContainer.addEventListener('scroll', updatePosition);

            // 클릭한 요소에 대한 ResizeObserver (크기가 변경될 경우 위치 업데이트)
            const resizeObserver = new ResizeObserver(updatePosition);
            resizeObserver.observe(element);

            // `.item_box`가 제거될 때 이벤트 정리
            itemBox.addEventListener('remove', () => {
                window.removeEventListener('scroll', updatePosition);
                window.removeEventListener('resize', updatePosition);
                lookContainer.removeEventListener('scroll', updatePosition);
                resizeObserver.disconnect();
            });
            
            /* 삭제 버튼 */
            const lookItemClose = document.querySelectorAll('.item_box .title .close'); // .look_item_wrap 요소들
            lookItemClose.forEach((close)=>{
                close.addEventListener('click', (event) => {
                    target_w.forEach(el => el.classList.remove('on'));
                    target_g.forEach(el => el.classList.remove('on'));
                    itemBox.remove();
                });
            });
        });
        
        
        //첫번째 target_w 강제 클릭
        setTimeout(() => {
            if (target_w.length > 0) {
                // `click()`이 있는 경우 일반 클릭 실행
                if (typeof target_w[0].click === "function") {
                    target_w[0].click();
                } else {
                    // `click()`이 없으면 `dispatchEvent`로 클릭 이벤트 발생
                    const event = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
                    target_w[0].dispatchEvent(event);
                }
            } else {
                console.warn("target_w[0]가 존재하지 않음");
            }
        }, 1000);

        
    });
});